import { GridProps } from "@mantine/core";

export const gridDefaultProps: Partial<GridProps> = {
    style: {
        margin: 0,
        padding: 0,
    },
    sx: {
        margin: 0,
        padding: 0,

        "& > div": {
            padding: 0,
            margin: 0,
        },
    },
};
